import React, { useState, useEffect, useRef } from "react";
import { Table, Row, Col, Collapse, Button } from "reactstrap";
//paginação
import Pagination from "../../../../components/Paginationv3";
// sessão mobile
import SectionComponent from "../../../Apps/Personalization/SectionComponent";
// service
import { getAccess } from "../../../../utils/services/dashboardSuperScreen";
// carregamento de tabela
import LoadingSkelentonTable from "../../../../components/loadingSkeletonTable";
// exportar tabela
import { createXlsx } from "./exports/createXlsxAccess";
// usedebounce
import useDebounce from "../../../../utils/hooks/useDebounce";
// componente de carregamento de exportação
import WaitExport from "../../../../components/WaitExport";
// moment
import moment from "moment";
// helpers
import { parseFirestoreDate } from "../../../../utils/helpers/files/formatDate";

export default function TableAccess(props) {
  const eventId = props.idEvent;
  const transmissionId = props.idDashboard;
  // modal collapse
  const [isOpen, setIsOpen] = useState(false);
  // pesquisa da listagem
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 300);
  //paginação
  const [currentIndex, setCurrentIndex] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [countData, setCountData] = useState(0);
  // força um novo fetch mesmo quando nenhum filtro mudou (botão Refresh)
  const [refreshKey, setRefreshKey] = useState(0);
  // export in progress
  const [exportInProgress, setExportInProgress] = useState(false);
  const [finishExport, setFinishExport] = useState(false);

  // formata a data do acesso para "DD/MM/AAAA - HH:mm"
  function formatDate(date) {
    const parsedDate = parseFirestoreDate(date);
    if (!parsedDate) return "";

    return moment(parsedDate).format("DD/MM/YYYY - HH:mm");
  }

  function exportReport() {
    createXlsx({
      eventId: eventId,
      transmissionID: transmissionId,
      limit: itemsPerPage,
      offset: currentIndex - 1,
      search: "",
      countData: countData,
      mobileapps: props.mobileapps,
      setFinishExport,
    });
    setExportInProgress(true);
  }

  function getAllAccess() {
    if (!props.mobileapps) return;
    getAccess({
      eventId: eventId,
      transmissionID: transmissionId,
      pageSize: itemsPerPage,
      offset: currentIndex - 1,
      search: debouncedSearch,
      mobileapps: props.mobileapps,
    }).then((res) => {
      if (res.success) {
        setCountData(res.total);
        props.setTableData((state) => {
          return {
            ...state,
            access: {
              loading: false,
              data: res.data,
              total: res.total,
            },
          };
        });
      }
    });
  }

  // atualiza o termo pesquisado e volta para a primeira página, senão a busca
  // sairia com o offset da página em que o usuário estava
  function handleSearch(value) {
    setSearch(value.toLowerCase());
    setCurrentIndex(1);
  }

  // volta a listagem para o estado inicial. O incremento do refreshKey dispara o
  // refetch pelo useEffect, já com o state atualizado, em vez de chamar o fetch
  // aqui com os valores antigos do render
  function resetPagination() {
    setSearch("");
    setItemsPerPage(10);
    setCurrentIndex(1);
    setRefreshKey((key) => key + 1);
  }

  useEffect(() => {
    // enquanto o debounce não fecha, search e debouncedSearch divergem e o fetch
    // sairia com o termo antigo. O próprio debounce dispara este efeito de novo
    if (search !== debouncedSearch) return;

    getAllAccess();
  }, [
    debouncedSearch,
    itemsPerPage,
    currentIndex,
    props.mobileapps,
    refreshKey,
  ]);

  return (
    <div>
      <WaitExport
        isOpen={exportInProgress}
        name="Relatório"
        preposicao="dos"
        finishExport={finishExport}
        setFinishExport={setFinishExport}
        setExportInProgress={setExportInProgress}
      />
      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
          margin: "10px 0",
        }}
      >
        <form
          className="app-search d-none d-lg-block events-input-search"
          onSubmit={(e) => e.preventDefault()}
        >
          <div className="position-relative">
            <input
              type="text"
              className="form-control"
              placeholder="Pesquisar..."
              value={search}
              onChange={(e) => handleSearch(e.target.value)}
            />
            <span className="bx bx-search-alt" />
          </div>
        </form>

        <div className="mobile-btn-section" style={{ width: "100%" }}>
          <Row className="mobile-btns-top">
            <form
              className="app-search"
              style={{ padding: "0px" }}
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="position-relative">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Pesquisar..."
                  value={search}
                  onChange={(e) => handleSearch(e.target.value)}
                />
                <span className="bx bx-search-alt" />
              </div>
            </form>
          </Row>
          {props.tableData.access.data.length > 0 && (
            <>
              <SectionComponent
                sectionName="Opções"
                setIsOpen={setIsOpen}
                isOpen={isOpen}
              />
              <Collapse isOpen={isOpen}>
                <Row className="mobile-btns-top">
                  <div onClick={() => exportReport()}>Exportar Acessos</div>
                </Row>
              </Collapse>
            </>
          )}
        </div>

        <div className="header-btns-container">
          {props.tableData.access.data.length > 0 && (
            <Button
              color="success"
              className="btn-rounded waves-effect waves-light events-button-add"
              onClick={() => exportReport()}
            >
              Exportar Acessos
            </Button>
          )}
        </div>
      </div>

      <div
        style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}
      >
        <a className="btn-reset-table" onClick={() => resetPagination()}>
          <i className="mdi mdi-refresh" style={{ marginRight: 5 }} />
          Refresh
        </a>
      </div>

      <div className="table-responsive" style={{ backgroundColor: "white" }}>
        <Table className="table mb-0">
          <thead className="table-light">
            <tr>
              <th>ID do Participante</th>
              <th>Nome</th>
              <th>Data e hora</th>
            </tr>
          </thead>

          <tbody>
            {props.tableData.access.loading ? (
              <LoadingSkelentonTable lines={3} cols={3} />
            ) : (
              props.tableData.access.data.map((e, i) => (
                <tr key={i}>
                  <td>{e.id}</td>
                  <td>{e.name}</td>
                  <td>{formatDate(e.date)}</td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </div>
      <Row style={{ marginTop: 20 }}>
        <Col md={12}>
          <Pagination
            data={props.tableData.access.data}
            search={search}
            currentIndex={currentIndex}
            setCurrentIndex={setCurrentIndex}
            countData={countData}
            maxItemPerPage={itemsPerPage}
            setMaxItemPerPage={setItemsPerPage}
            maxPageButtonsToShow={3}
          />
        </Col>
      </Row>
    </div>
  );
}
